import { ICustomersState } from "../types";
import { SET_SELECTED_SORT_OPTION, SET_FILTERS_STATE, SET_FULL_NAME_LIST } from "./Customers.actions";


export function CustomersReducer(state: ICustomersState, action: { type: string, payload: any; }) {
    switch (action.type) {
        case SET_SELECTED_SORT_OPTION:
            return {
                ...state,
                selectedSortOption: action.payload,
            };
        case SET_FILTERS_STATE:
            return {
                ...state,
                filterState: action.payload,
            }
        case SET_FULL_NAME_LIST:
            return {
                ...state,
                nameSearchList: action.payload
            }
    }
    return state;
}
